import React, { useEffect, useRef, useState } from "react";
import { Divider, getIcons, MenuItem, userRole } from "../../Constant/Constant";
import BackArrows from "../../Form/BackArrow/BackArrows";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

import { MdKeyboardArrowRight } from "react-icons/md";
import { MdEdit } from "react-icons/md";

import leadSourceService from "../../Services/LeadSourceService";
import WebhooksService from "../../Services/WebhooksService";
import CustomHeading from "../../common/CustomHeading";

const ConnectedPage = () => {
  const location = useLocation();
  const Icon = getIcons();
  const menuRef = useRef(null);
  const [pagesData, setPagesData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [leadSource, setLeadSource] = useState();
  const [filterLeadSource, setFilterLeadSource] = useState();
  const [search, setSearch] = useState("");
  const [selectedLeadSourceOption, setSelectedLeadSourceOption] =
    useState(null);
  const [selectedPageId, setSelectedPageId] = useState(null);

  const navigate = useNavigate();
  const [visibleMenu, setVisibleMenu] = useState(false);

  const selectedMedia = location.state.selectedMedia;

  const handleBack = () => {
    navigate(-1);
  };

  const handleMenuToggle = () => {
    setVisibleMenu(!visibleMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setVisibleMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleFormPageList = (item) => {
    const path = userRole === "Admin" ? "/admin" : "/cmo";

    navigate(`${path}/web-hooks-form-list`, {
      state: {
        formName: item.formName,
        leadCount: item.leadCount,
      },
    });
  };
  useEffect(() => {
    const fetchLeadSources = async () => {
      try {
        const response = await leadSourceService.fetchLeadSources();

        const data = response.data;
        let optionsArray = [];
        data.forEach((item) => {
          optionsArray.push({ value: item.id, label: item.name });
        });
        setLeadSource(optionsArray);
        setFilterLeadSource(optionsArray);
      } catch (error) {
        console.error("Error fetching lead source:", error);
      }
    };

    fetchLeadSources();
  }, []);

  const fetchPages = async () => {
    try {
      const response = await WebhooksService.fetchFbPages();
      setPagesData(response.data);
    } catch (error) {
      console.error("Error fetching pages:", error);
    }
  };
  useEffect(() => {
    fetchPages();
  }, []);
  const getLeadSourceName = (id) => {
    const source = leadSource.find((s) => s.value === id);
    return source?.label || "Unknown";
  };

  const openLeadSourceModal = (pageId) => {
    const selectedPage = pagesData.find((p) => p.docId === pageId);
    setSelectedPageId(pageId);
    setSelectedLeadSourceOption(selectedPage?.leadSource?.id || null);
    setShowModal(true);
  };

  const handleSubmitLeadSource = async () => {
    if (selectedLeadSourceOption && selectedPageId) {
      try {
        let obj = {
          docId: selectedPageId,
          leadSourceId: selectedLeadSourceOption,
        };
        const response = await WebhooksService.updateLeadSource(obj);

        if (response.status === 200) {
          const updatedPages = pagesData.map((page) =>
            page.id === selectedPageId
              ? {
                  ...page,
                  leadSource: {
                    id: selectedLeadSourceOption,
                    name: getLeadSourceName(selectedLeadSourceOption),
                  },
                }
              : page
          );
          setPagesData(updatedPages);
          setShowModal(false);
          fetchPages();
        }
      } catch (error) {
        console.error("Failed to update lead source:", error);
      }
    }
  };

  const handleToggle = async (pageId) => {
    try {
      const updatedPages = pagesData.map((page) =>
        page.docId === pageId
          ? { ...page, isSubscribed: !page.isSubscribed }
          : page
      );
      setPagesData(updatedPages);

      const targetPage = updatedPages.find((p) => p.docId === pageId);
      await WebhooksService.updateSubscriptionStatus({
        docId: pageId,
        isSubscribed: targetPage.isSubscribed,
      });
    } catch (error) {
      console.error("Failed to toggle subscription:", error);
    }
  };

  const handleSearchLeadSource = (e) => {
    const searchValue = e.target.value;

    const filterSource = leadSource.filter((item) =>
      item.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilterLeadSource(filterSource);
  };

  return (
    <>
      <div className="pt-14 bg-appGrayBackground ">
        <AdminAppBar />
        <ToastContainer />

        {/* {Heading and Search , add } */}
        <div className="mt-[50px] px-6 flex justify-between">
          <div className="flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-6">
                <CustomHeading
                  title={`${selectedMedia} Integrations`}
                  isIcon={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="px-16 pt-5">
          <div className="">
            <div className="flex items-center justify-between py-4 ">
              <div className="text-2xl font-medium">Connected Pages </div>
            </div>

            <div className="bg-white rounded-[10px] p-2 shadow-sm">
              <div className="overflow-x-auto">
                <table className="w-full ">
                  <thead>
                    <tr className="bg-gray-100  text-base text-center rounded-md">
                      <th className="px-4 py-3 text-gray-700 font-medium">
                        S.no
                      </th>
                      <th className="px-4 py-3 text-gray-700 font-medium">
                        Pages{" "}
                      </th>
                      <th className="px-4 py-3 text-gray-700 font-medium">
                        Status
                      </th>
                      <th className="px-4 py-3 text-gray-700 font-medium">
                        Lead source
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {pagesData.map((page, index) => (
                      <tr
                        key={page.id}
                        className="border-b text-center border-gray-200 hover:bg-gray-50"
                      >
                        <td className="px-4 text-sm py-4">{index + 1}</td>
                        <td className="px-4 py-4 text-sm">{page.pageName}</td>
                        {/* <td className="px-4 py-4 text-sm">
                          <span
                      className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(page.isSubscribed)}`}
                    >
                          {page.isSubscribed ? "Subscribed" : "Not Subscribed"}
                          </span>
                        </td> */}

                        <td className="px-4 py-4 text-sm">
                          <label className="flex items-center justify-center gap-2 cursor-pointer">
                            <span className="text-xs font-medium text-red-600">
                              Unsubscribe
                            </span>

                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={page.isSubscribed}
                              onChange={() => handleToggle(page.docId)}
                            />

                            <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />

                            <span className="text-xs font-medium text-green-600">
                              Subscribe
                            </span>
                          </label>
                        </td>

                        <td className="px-4 py-4 text-sm">
                          {/* {page.leadSource?.name ? (
          page.leadSource.name
        ) : (
          <button
            onClick={() => openLeadSourceModal(page.docId)}
            className="text-blue-500 underline"
          >
            + Add Lead Source
          </button>
        )} */}

                          {page.leadSource?.name ? (
                            <div className="flex items-center justify-center gap-2">
                              <span>{page.leadSource.name}</span>
                              <button
                                onClick={() => openLeadSourceModal(page.docId)}
                                className="text-blue-500 hover:text-blue-700"
                                title="Edit Lead Source"
                              >
                                <MdEdit className="text-lg" />
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => openLeadSourceModal(page.docId)}
                              className="h-10 bg-customGreen rounded-lg w-fit p-2 text-white"
                            >
                              + Add Lead Source
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>

                  {/* {showModal && (
                    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                      <div className="bg-white w-[400px] rounded-lg p-6 shadow-lg">
                        <h2 className="text-xl font-semibold mb-4">
                          Select Lead Source
                        </h2>
                        <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
                          {leadSource.map((source) => (
                            <label
                              key={source.value}
                              className="flex items-center gap-2 cursor-pointer"
                            >
                              <input
                                type="radio"
                                name="leadSource"
                                value={source.value}
                                checked={
                                  selectedLeadSourceOption === source.value
                                }
                                onChange={() =>
                                  setSelectedLeadSourceOption(source.value)
                                }
                              />
                              {source.label}
                            </label>
                          ))}
                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                          <button
                            onClick={() => setShowModal(false)}
                            className="px-4 py-2 bg-gray-300 rounded-md"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleSubmitLeadSource}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  )} */}

                  {showModal && (
              <div
              className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
              role="dialog"
              aria-modal="true"
              aria-labelledby="bulk-upload-title"
            >
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md sm:max-w-lg p-6 transition-all">
                {/* Header */}
                <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
                <h2
                    id="bulk-upload-title"
                    className="text-xl font-semibold text-green-700"
                  >
                    Select Lead Source
                  </h2>
                  <button
                    onClick={() => setShowModal(false)}
                    className="text-red-600 bg-white  focus:outline-none  rounded-full p-1"
                    aria-label="Close modal"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
            
                {/* Search Input */}
                <div className="mb-4">
                  <input
                    onChange={handleSearchLeadSource}
                    type="text"
                    placeholder="Search Lead Source"
                    className="w-full p-3 rounded-lg border border-gray-300  input-focus"
                  />
                </div>
            
                {/* Lead Source Options */}
                <div className="flex flex-col gap-3 max-h-64 overflow-y-auto px-1">
                  {filterLeadSource?.map((source) => (
                    <label
                      key={source.value}
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-100 transition cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="leadSource"
                        value={source.value}
                        checked={selectedLeadSourceOption === source.value}
                        onChange={() => setSelectedLeadSourceOption(source.value)}
                        className="accent-blue-600"
                      />
                      <span className="text-gray-700">{source.label}</span>
                    </label>
                  ))}
                </div>
            
                {/* Action Buttons */}
                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 rounded-md border bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmitLeadSource}
                    className="px-4 py-2 rounded-md bg-customGreen text-white transition"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectedPage;
